import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowUpRightSm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m14.777 16-6.683-.094m0 0L8 9.224m.094 6.682L16 8"
    />
  </svg>
);
export default SvgArrowUpRightSm;
